'use strict';

$(document).ready(function () {
    require('./storeLocator/storeLocatorDetail').init();
});
